export const ANALYSIS_DESI_ALL = 'ANALYSIS_DESI_ALL';
export const ANALYTICS_FILTER_SUCCESS = 'ANALYTICS_FILTER_SUCCESS';
export const ANALYSIS_DESI_SINGLE = 'ANALYSIS_DESI_SINGLE';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const ANALYSIS_DESI_LIST_SUCCESS = 'ANALYSIS_DESI_LIST_SUCCESS';
export const BATCHJOB_DEFINITION_DATA = 'BATCHJOB_DEFINITION_DATA';
export const BATCHJOB_DEFINITION_SINGLE = 'BATCHJOB_DEFINITION_SINGLE';
